import React from 'react';
import styles from './DemoTag.module.css';

/**
 * Selo "Exemplo" dos dados de exemplo da conta de teste, no mesmo formato dos
 * selos "Inativa"/"Ativo" das listas. label troca o texto (ex.: "Ficha de exemplo");
 * compact é a versão pequena para os cards da agenda.
 */
function DemoTag({ label = 'Exemplo', compact = false, className = '' }) {
  return (
    <span className={`${styles.tag} ${compact ? styles.compact : ''} ${className}`} title="Dado de exemplo: não envia mensagens e não conta como uso">
      {label}
    </span>
  );
}

export default DemoTag;
